var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloaded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M750.2,481.5c-132.4,0-239.8,107.4-239.8,239.8c0,132.4,107.4,239.8,239.8,239.8c132.4,0,239.8-107.4,239.8-239.8C990,588.9,882.6,481.5,750.2,481.5z M883.5,660.7L747.7,810.3c-16.1,17.7-42.7,18.9-59.9,2.6l-69.7-66.3c-10.1-9.7-10.5-25.7-0.9-35.9c9.7-10.1,25.7-10.5,35.8-0.9l63,59.9l129.9-143c9.4-10.4,25.4-11.2,35.8-1.7C892.1,634.4,892.9,650.4,883.5,660.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.2,578.2c5.9,5.9,13.5,8.8,21.2,8.8c7.7,0,15.3-2.9,21.2-8.8l228.3-228.3c11.7-11.7,11.7-30.7,0-42.4c-11.7-11.7-30.7-11.7-42.4,0L460.4,484.6V68.8c0-16.6-13.4-30-30-30c-16.6,0-30,13.4-30,30v415.8L223.3,307.5c-11.7-11.7-30.7-11.7-42.4,0c-11.7,11.7-11.7,30.7,0,42.4L409.2,578.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.1,784.3H169.5c-37,0-74.5-30.9-81.6-67.3l-18.5-94.8c-3.2-16.2-18.9-26.9-35.2-23.7c-16.2,3.2-26.9,18.9-23.7,35.2l18.5,94.8c12.6,64.5,74.8,115.7,140.4,115.7h291.6c16.6,0,30-13.4,30-30C491.1,797.7,477.7,784.3,461.1,784.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloaded);
export default __webpack_public_path__ + "static/media/downloaded.6947e15d.svg";
export { ForwardRef as ReactComponent };